import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useStaff } from "@/context/StaffContext";
import { ShieldCheck } from "lucide-react";

function CenterSpinner() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="animate-pulse text-slate-400 flex items-center gap-2">
        <ShieldCheck className="h-4 w-4" />
        <span className="text-sm">Chargement…</span>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { session } = useAuth();
  if (session === null) return <CenterSpinner />;
  if (!session) return <Navigate to="/login" replace />;
  return children;
}

export function StaffProtectedRoute({ children }) {
  const { staff } = useStaff();
  if (staff === null) return <CenterSpinner />;
  if (!staff) return <Navigate to="/staff/login" replace />;
  return children;
}
